/* eslint-disable no-duplicate-imports */
/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @angular-eslint/directive-class-suffix */
import { Input } from '@angular/core';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[logibidsSpaceAtFirst]',
  standalone: true,
})
export class appNoSpaceAtFirst {
  @Input() isAlphaNumeric = false;

  constructor(private el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.el.nativeElement.selectionStart === 0 && event.key === ' ') {
      event.preventDefault();
    }
  }
}
